import { useTranslation } from 'react-i18next';
import { Link } from '@tanstack/react-router';
import { Home, User } from 'lucide-react';
import { UserButton, SignedIn } from '@clerk/clerk-react';
import { Languages } from 'lucide-react';
import { LanguageSelector } from '@/shared/components/user-button/LanguageSelector';
import { cn } from '@/shared/lib/utils';

export const MobileBottomNav = () => {
  const { t } = useTranslation('common');

  const navItemClassName =
    'flex flex-col items-center justify-center gap-1 px-3 py-2 rounded-lg transition-all duration-200 min-w-[64px] min-h-[56px] hover:bg-accent text-muted-foreground';

  return (
    <SignedIn>
      <nav className="mobile-bottom-nav md:hidden bg-white border-t border-border/50 shadow-lg">
        <div className="flex items-center justify-around px-2 py-2 safe-area-pb">
          <Link
            to="/"
            activeOptions={{ exact: true, includeSearch: false }}
            className={navItemClassName}
            activeProps={{
              className: cn(
                navItemClassName,
                'bg-accent text-foreground font-semibold'
              ),
            }}
          >
            <Home className="h-5 w-5 shrink-0" aria-hidden />
            <span className="text-[10px] leading-tight text-center truncate max-w-full">
              {t('home')}
            </span>
          </Link>
          {/* Profile Button with Clerk's Built-in Modal */}
          <div className="flex flex-col items-center justify-center gap-1 px-3 py-2 rounded-lg transition-all duration-200 min-w-[64px] min-h-[56px] hover:bg-accent text-muted-foreground relative">
            <div className="absolute inset-0 flex items-center justify-center opacity-0">
              <UserButton
                appearance={{
                  elements: {
                    userButtonBox: 'w-full h-full',
                    userButtonTrigger:
                      'w-full h-full bg-transparent hover:bg-transparent',
                    userButtonAvatarBox: 'w-5 h-5 bg-transparent',
                    userButtonAvatarImage: 'hidden',
                    userButtonPopoverCard: 'max-w-[95vw] max-h-[90vh]',
                  },
                }}
              >
                <UserButton.UserProfilePage
                  label={t('language')}
                  labelIcon={<Languages className="h-4 w-4" />}
                  url="language"
                >
                  <div className="space-y-4 p-6">
                    <div className="space-y-1">
                      <h2 className="text-xl font-semibold">{t('language')}</h2>
                      <p className="text-sm text-muted-foreground">
                        {t('selectYourPreferredLanguage')}
                      </p>
                    </div>
                    <LanguageSelector />
                  </div>
                </UserButton.UserProfilePage>
              </UserButton>
            </div>
            <User
              className="h-5 w-5 shrink-0 pointer-events-none"
              aria-hidden
            />
            <span className="text-[10px] leading-tight text-center truncate max-w-full pointer-events-none">
              {t('profile')}
            </span>
          </div>
        </div>
      </nav>
    </SignedIn>
  );
};
